import * as React from 'react';
import styled from 'styled-components';
import { createVideoPreviewUrl, createVideoUrl } from '../../../cloudinary';
import Button from '../../../components/Button';
import { Answer } from '../../../types/api';
import { ApplicationState, Question } from '../types';

interface ViewOwnVideoProps {
    question: Question;
    answer: Answer;
    onRetry: () => void;
    applicationState: ApplicationState;
}

const VideoFrame = styled.div`
    margin-bottom: 1rem;
`;

const ViewOwnVideo: React.FC<ViewOwnVideoProps> = props => {
    const answerVideoLink = createVideoUrl(props.answer.videoLink!);
    return (
        <div>
            <VideoFrame>
                <video
                    key={props.answer.videoLink}
                    controls={true}
                    autoPlay={false}
                    width="100%"
                    poster={createVideoPreviewUrl(props.answer!.videoLink!, 'w_480')}
                >
                    <source src={answerVideoLink} type="video/mp4" />
                </video>
            </VideoFrame>
            {props.applicationState === ApplicationState.INVITATION_SENT && (
                <Button onClick={props.onRetry}>Make new recording</Button>
            )}
        </div>
    );
};

export default ViewOwnVideo;



// WEBPACK FOOTER //
// ./src/scenes/candidate/components/ViewOwnVideo.tsx